import { TemplateRef } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-generic-form-container',
  templateUrl: './generic-form-container.component.html',
})
export class GenericFormContainerComponent {

  @Input() readonly form: FormGroup;
  @Input() readonly controlsTemplate: TemplateRef<any>;

  @Input() readonly showCancelButton: boolean = false;
  @Input() readonly showSubmitButton: boolean = true;

  @Input() readonly cancelLabel: string = 'Cancel';
  @Input() readonly submitLabel: string = 'Submit';

  @Output() readonly cancelled = new EventEmitter<void>();
  @Output() readonly submitted = new EventEmitter<void>();

}
